import { type CSSProperties, memo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';

import { FileGalleryCard, type FileGalleryCardProps } from '~/components/Gallery/FileGalleryCard/FileGalleryCard';
import { DndSortableKanbanItem } from '~/components/KanbanView/KanbanColumnsManagers/shared/KanbanColumnItems/KanbanItem/shared/DndSortableKanbanItem';
import { KANBAN_ITEM_CARD_WIDTH } from '~/components/KanbanView/shared/kanbanConstants';
import { type DndSortableKanbanItemData } from '~/types/DndKit';

type KanbanFileComponentProps<C> = {
  dndDisabled?: boolean;
  kanbanDndItemData: DndSortableKanbanItemData;
  style: CSSProperties;
} & Omit<FileGalleryCardProps<C>, 'cardWidth'>;

const _KanbanFileComponent = <C extends Clip | PublicClip>({
  dndDisabled,
  kanbanDndItemData,
  style,
  cardHeight,
  ...rest
}: KanbanFileComponentProps<C>) => {
  return (
    <DndSortableKanbanItem
      style={style}
      id={kanbanDndItemData.sortableKanbanItemKey}
      data={kanbanDndItemData}
      dndDisabled={dndDisabled}
    >
      <div className="relative" style={{ height: cardHeight }}>
        <FileGalleryCard
          cardWidth={KANBAN_ITEM_CARD_WIDTH}
          // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the color pairing
          getButtonClassName={() =>
            'ads:bg-base bg-gray-1 cursor-pointer shadow-md shadow-kanban dark:border ads:dark:border-default dark:border-gray-4'
          }
          cardHeight={cardHeight}
          {...rest}
        />
      </div>
    </DndSortableKanbanItem>
  );
};

// biome-ignore lint/plugin: memo erases generic params; typeof cast restores inference
export const KanbanFileComponent = memo(_KanbanFileComponent) as typeof _KanbanFileComponent;
